import { render, staticRenderFns } from "./Power.vue?vue&type=template&id=7488e3c5&scoped=true"
import script from "./Power.vue?vue&type=script&lang=js"
export * from "./Power.vue?vue&type=script&lang=js"
import style0 from "./Power.vue?vue&type=style&index=0&id=7488e3c5&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7488e3c5",
  null
  
)

export default component.exports